import { createSelector } from 'reselect';

const selectDBNDomainAccountMappings = (state: any) => state.dbnDomainAccountMappings;


export const selectDBNDomainAccountMappingsCurrentItem = createSelector([selectDBNDomainAccountMappings], (dbnDomainAccountMappings) => dbnDomainAccountMappings.current);

export const selectDBNDomainAccountMappingsListItems = createSelector([selectDBNDomainAccountMappings], (dbnDomainAccountMappings) => dbnDomainAccountMappings.list);

export const selectDBNDomainAccountMappingsItemById = (itemId: any) =>
    createSelector(selectDBNDomainAccountMappingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDBNDomainAccountMappingsQueryItems = createSelector([selectDBNDomainAccountMappings], (dbnDomainAccountMappings) => dbnDomainAccountMappings.query);

export const selectDBNDomainAccountMappingsCreatedItem = createSelector([selectDBNDomainAccountMappings], (dbnDomainAccountMappings) => dbnDomainAccountMappings.create);

export const selectDBNDomainAccountMappingsUpdatedItem = createSelector([selectDBNDomainAccountMappings], (dbnDomainAccountMappings) => dbnDomainAccountMappings.update);

export const selectDBNDomainAccountMappingsReadItem = createSelector([selectDBNDomainAccountMappings], (dbnDomainAccountMappings) => dbnDomainAccountMappings.read);

export const selectDBNDomainAccountMappingsDeletedItem = createSelector([selectDBNDomainAccountMappings], (dbnDomainAccountMappings) => dbnDomainAccountMappings.delete);

export const selectDBNDomainAccountMappingsearchedItems = createSelector([selectDBNDomainAccountMappings], (dbnDomainAccountMappings) => dbnDomainAccountMappings.search);

export const selectDBNDomainAccountMappingsItemsCount = createSelector([selectDBNDomainAccountMappings], (dbnDomainAccountMappings) => dbnDomainAccountMappings.count);

export const selectDBNDomainAccountMappingsItemsFilter = createSelector([selectDBNDomainAccountMappings], (dbnDomainAccountMappings) => dbnDomainAccountMappings.filter);